import * as React from 'react';
import { useState, useEffect } from 'react';
import {
  Gradient,
  InterventionsLogo,
  InterventionsHover,
  LogoParent,
} from './NavGradient.style';
import { icons } from '../../style/icons';
import { MarginContainer } from '../../lib/shared';
import { NavLink } from '../../lib/shared';

const NavGradient = () => {
  const [navAnimation, setNavAnimation] = useState(false);
  useEffect(() => {
    setNavAnimation(
      typeof window !== `undefined` && window.location.pathname === '/'
    );
  });

  return (
    <Gradient>
      <MarginContainer>
        <NavLink href={'/'}>
          <LogoParent>
            <InterventionsLogo
              src={icons.INTERVENTIONS_WHITE_LOGO.image}
              alt={icons.INTERVENTIONS_WHITE_LOGO.altText}
            />
            <InterventionsHover
              src={
                navAnimation
                  ? icons.INTERVENTIONS_WHITE_LOGO.image
                  : icons.BLACK_LOGO.image
              }
              alt={
                navAnimation
                  ? icons.INTERVENTIONS_WHITE_LOGO.altText
                  : icons.BLACK_LOGO.altText
              }
            />
          </LogoParent>
        </NavLink>
      </MarginContainer>
    </Gradient>
  );
};

export default NavGradient;
